import Personal from 'components/personal/personal'
import Wallet from 'components/personal/wallet/wallet'
import WalletMingxi from 'components/personal/wallet/wallet-mingxi'
import WalletTxRecord from 'components/personal/wallet/wallet-tx-record'
import WalletFR from 'components/personal/wallet/wallet-fenrun'
import WalletDS from 'components/personal/wallet/wallet-dashang'
import WalletSpec from 'components/personal/wallet/wallet-spec'
import WalletTx from 'components/personal/wallet/wallet-tx'
// import WalletTxmx from 'components/personal/wallet/wallet-tx-mx'
// import Certification from '@/components/personal/certification/certification'
// import CertificationAll from '@/components/personal/certification/certification-all'
// import CertificationWk from '@/components/personal/certification/certification-wk'
// import CertificationTxk from '@/components/personal/certification/certification-txk'
// import CertificationSearch from '@/components/personal/certification/search'
import CertificationShare from '@/components/personal/certification/popup-share'
import Coupon from '@/components/personal/coupon/coupon'
import CouponUnused from '@/components/personal/coupon/coupon-unused'
import CouponUsed from '@/components/personal/coupon/coupon-used'
import CouponPast from '@/components/personal/coupon/coupon-past'
import CouponSpec from '@/components/personal/coupon/coupon-spec'
// import Bought from '@/components/personal/bought/bought'
// import BoughtAll from '@/components/personal/bought/bought-all'
// import BoughtWk from '@/components/personal/bought/bought-wk'
// import BoughtTxk from '@/components/personal/bought/bought-txk'
// import BoughtSearch from '@/components/personal/bought/search'
import BindGolo from '@/components/personal/bind/bind'
import MyFollow from '@/components/personal/follow'
import VipIndex from '@/components/personal/vip'
import BuyVip from '@/components/personal/vip/buy-vip'
import VipAgree from '@/components/personal/vip/agree'
import Bindphone from '@/components/personal/bindphone'
import Bindsuccess from '@/components/personal/bindphone/success'
import MyIntegral from '@/components/personal/integral'
import MyIntegralRule from '@/components/personal/integral/rule'
export const personalRouter = [
  // 个人中心
  {
    path: '/personal',
    component: Personal,
    meta: {
      title: '我的',
      id: 26
    }
  },
  // 我的钱包
  {
    path: '/personal/wallet',
    component: Wallet,
    meta: {
      title: '我的钱包',
      id: 27
    }
  },
  // 零钱(分润)明细
  {
    path: '/personal/wallet/mx',
    component: WalletMingxi,
    meta: {
      id: 28
    },
    children: [
      {
        path: '/',
        redirect: 'fr'
      },
      {
        path: 'fr',
        component: WalletFR,
        meta: {
          id: 29
        }
      },
      {
        path: 'ds',
        component: WalletDS,
        meta: {
          id: 30
        }
      }
    ]
  },
  // 提现记录
  {
    path: '/personal/wallet/txjl',
    component: WalletTxRecord,
    meta: {
      id: 31
    }
  },
  // 1.5版本 钱包改版
  {
    path: '/personal/wallet/spec',
    component: WalletSpec,
    meta: {
      title: '钱包与收入说明'
    }
  },
  {
    path: '/personal/wallet/tx',
    component: WalletTx,
    meta: {
      title: '提现'
    }
  },
  {
    path: '/personal/wallet/txmx',
    // component: WalletTxmx,
    component: WalletTxRecord,
    meta: {
      title: '申请记录'
    }
  },
  /*
  // 我的证书
  {
    path: '/personal/certification',
    component: Certification,
    meta: {
      id: 32
    },
    children: [
      {
        path: '/',
        redirect: 'all'
      },
      {
        path: 'all',
        component: CertificationAll,
        meta: {
          title: '我的证书',
          id: 33
        }
      },
      {
        path: 'wk',
        component: CertificationWk,
        meta: {
          title: '我的证书',
          id: 34
        }
      },
      {
        path: 'txk',
        component: CertificationTxk,
        meta: {
          title: '我的证书',
          id: 35
        }
      }
    ]
  },
  // 我的证书搜索
  {
    path: '/personal/certification/search',
    component: CertificationSearch,
    meta: {
      title: '我的证书',
      id: 36
    }
  }, */
  // 我的证书分享页
  {
    path: '/personal/certification/share',
    component: CertificationShare,
    meta: {
      title: '我的证书',
      id: 37
    }
  },
  // 我的优惠券
  {
    path: '/personal/coupon',
    component: Coupon,
    meta: {
      title: '优惠券',
      id: 38
    },
    children: [
      {
        path: '/',
        redirect: 'unused'
      },
      {
        path: 'unused',
        component: CouponUnused,
        meta: {
          title: '优惠券',
          id: 39
        }
      },
      {
        path: 'used',
        component: CouponUsed,
        meta: {
          title: '优惠券',
          id: 40
        }
      },
      {
        path: 'past',
        component: CouponPast,
        meta: {
          title: '优惠券',
          id: 41
        }
      }
    ]
  },
  // 优惠券使用说明
  {
    path: '/personal/coupon/spec',
    component: CouponSpec,
    meta: {
      title: '使用说明',
      id: 42
    }
  },
  /*
  // 已购课程
  {
    path: '/personal/bought',
    component: Bought,
    meta: {
      title: '已购课程',
      id: 43
    },
    children: [
      {
        path: '/',
        redirect: 'all'
      },
      {
        path: 'all',
        component: BoughtAll,
        meta: {
          title: '已购课程',
          id: 44
        }
      },
      {
        path: 'wk',
        component: BoughtWk,
        meta: {
          title: '已购课程',
          id: 45
        }
      },
      {
        path: 'txk',
        component: BoughtTxk,
        meta: {
          title: '已购课程',
          id: 46
        }
      }
    ]
  },
  // 已购课程 搜索
  {
    path: '/personal/bought/search',
    component: BoughtSearch,
    meta: {
      title: '已购课程',
      id: 47
    }
  }, */
  // 绑定golo账号
  {
    path: '/personal/bind/bind',
    component: BindGolo,
    meta: {
      title: '绑定golo账户'
    }
  },
  // 我关注的大咖
  {
    path: '/personal/follow',
    component: MyFollow,
    meta: {
      title: '关注的大咖'
    }
  },
  // vip相关
  {
    path: '/vip',
    component: VipIndex,
    children: [
      {
        path: '/',
        redirect: 'buy'
      },
      {
        path: 'buy',
        component: BuyVip,
        meta: {
          title: '购买会员'
        }
      },
      {
        path: 'buy/:type',
        component: BuyVip,
        meta: {
          title: '购买会员'
        },
        props: true
      },
      {
        path: 'agree',
        component: VipAgree,
        meta: {
          title: '轱辘会员服务协议'
        }
      }
    ]
  },
  // 绑定手机
  {
    path: '/personal/bindphone',
    component: Bindphone,
    meta: {
      title: '绑定手机'
    }
  },
  {
    path: '/personal/bindsuccess',
    component: Bindsuccess,
    meta: {
      title: '绑定成功'
    }
  },
  // 我的积分
  {
    path: '/personal/integral',
    component: MyIntegral,
    meta: {
      title: '我的积分'
    }
  },
  {
    path: '/personal/integral/rule',
    component: MyIntegralRule,
    meta: {
      title: '积分规则'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/personal.js